import { ROUTES } from '../../../../constants/app'

/** One breadcrumb step: a label, and the page it leads to (if any). */
export interface PlayerTrailItem {
  label: string
  to?: string
}

interface TeamPlayerTrailArgs {
  organization?: { id?: string | null; name_full?: string | null } | null
  team: { id: string; name?: string | null }
}

/**
 * The breadcrumb for a roster player's screens opened from a team (its roster
 * or its Team Budget): `Org › Team`, each a link to its page. A step whose
 * name has not loaded is left out rather than shown blank.
 */
export const teamPlayerTrail = ({
  organization,
  team,
}: TeamPlayerTrailArgs): PlayerTrailItem[] => {
  const trail: PlayerTrailItem[] = []
  if (organization?.id && organization.name_full) {
    trail.push({
      label: organization.name_full,
      to: `${ROUTES.ORG_ROOT}/${organization.id}`,
    })
  }
  if (team.name) {
    trail.push({ label: team.name, to: `${ROUTES.TEAM_ROOT}/${team.id}` })
  }
  return trail
}
